import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ActionSection, CombineInputGroup, FieldWrapper, InputGroup, Label, ScrollableContent, SideCancelBtn, SubmitBtn, Wrapper } from "../Styles/InputStyles";

const AddFoodMenu = ({ handleClose, selectedData, addMenuLoading, addMenuMutate, propId, editMenuLoading, editMenuMutate, }) => {

    const parseTimeString = (timeStr) => {
        if (!timeStr) return null;

        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            const timePart = timeStr.split(' ')[0];
            const period = timeStr.split(' ')[1].toLowerCase();

            let [hours, minutes] = timePart.split(':').map(Number);

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }

            const date = new Date();
            date.setHours(hours, minutes);
            return date;
        }

        const [hours, minutes] = timeStr.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes);
        return date;
    };

    const formatTimeForBackend = (date) => {
        if (!date) return '';
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };


    const initialDayOfWeek = selectedData?.dayOfWeek || new Date().getDay() || 7

    const initialValues = {
        dayOfWeek: initialDayOfWeek,
        breakfast: {
            startTime: parseTimeString(selectedData?.breakfastTiming?.split(' - ')[0]),
            endTime: parseTimeString(selectedData?.breakfastTiming?.split(' - ')[1]),
            details: selectedData?.breakfast || ''
        },
        lunch: {
            startTime: parseTimeString(selectedData?.lunchTiming?.split(' - ')[0]),
            endTime: parseTimeString(selectedData?.lunchTiming?.split(' - ')[1]),
            details: selectedData?.lunch || ''
        },
        snacks: {
            startTime: parseTimeString(selectedData?.snackTiming?.split(' - ')[0]),
            endTime: parseTimeString(selectedData?.snackTiming?.split(' - ')[1]),
            details: selectedData?.snack || ''
        },
        dinner: {
            startTime: parseTimeString(selectedData?.dinnerTiming?.split(' - ')[0]),
            endTime: parseTimeString(selectedData?.dinnerTiming?.split(' - ')[1]),
            details: selectedData?.dinner || ''
        }
    };

    const handleSubmit = (values) => {
        const hasAtLeastOneMeal = ['breakfast', 'lunch', 'snacks', 'dinner'].some(meal =>
            values[meal].details && values[meal].startTime && values[meal].endTime
        );

        if (!hasAtLeastOneMeal) {
            toast.error("Please fill at least one complete meal section");
            return;
        }

        const hasPartialMeals = ['breakfast', 'lunch', 'snacks', 'dinner'].some(meal => {
            const section = values[meal];

            return (
                (section.details || section.startTime || section.endTime) &&
                !(section.details && section.startTime && section.endTime)
            );
        });

        if (hasPartialMeals) {
            toast.error("Please complete all fields for any meal section you start, or leave it empty");
            return;
        }


        const payload = {
            propId: propId,
            dayOfWeek: initialDayOfWeek,
            breakfast: values.breakfast.details,
            breakfastTiming: values.breakfast.details
                ? `${formatTimeForBackend(values.breakfast.startTime)} - ${formatTimeForBackend(values.breakfast.endTime)}`
                : '',
            lunch: values.lunch.details,
            lunchTiming: values.lunch.details
                ? `${formatTimeForBackend(values.lunch.startTime)} - ${formatTimeForBackend(values.lunch.endTime)}`
                : '',
            snacks: values.snacks.details,
            snacksTiming: values.snacks.details
                ? `${formatTimeForBackend(values.snacks.startTime)} - ${formatTimeForBackend(values.snacks.endTime)}`
                : '',
            dinner: values.dinner.details,
            dinnerTiming: values.dinner.details
                ? `${formatTimeForBackend(values.dinner.startTime)} - ${formatTimeForBackend(values.dinner.endTime)}`
                : '',
            ...(selectedData.id && { menuId: selectedData.id })
        };

        if (selectedData.id) {
            editMenuMutate(payload);
        } else {
            addMenuMutate(payload);
        }
    }
    return (
        <Container>
            <Header>
                <Title>{selectedData.id ? "Edit Menu" : "Add Menu"}</Title>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <div className="px-6 h-full flex flex-col justify-between custom-scrollbar">
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue }) => (
                        <Form >
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    {/* Breakfast Section */}
                                    <MealSection>
                                        <MealTitle>Breakfast</MealTitle>
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label>Start Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.breakfast.startTime}
                                                        onChange={(date) => setFieldValue('breakfast.startTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label>End Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.breakfast.endTime}
                                                        onChange={(date) => setFieldValue('breakfast.endTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                        </CombineInputGroup>

                                        <InputGroup className="md:mt-2">
                                            <Label>Breakfast Details</Label>
                                            <FieldWrapper>
                                                <Field
                                                    as="textarea"
                                                    name="breakfast.details"
                                                    placeholder="Enter breakfast menu details"
                                                    className="details-input"
                                                />
                                            </FieldWrapper>
                                        </InputGroup>
                                    </MealSection>

                                    {/* Lunch Section */}
                                    <MealSection>
                                        <MealTitle>Lunch</MealTitle>
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label>Start Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.lunch.startTime}
                                                        onChange={(date) => setFieldValue('lunch.startTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label>End Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.lunch.endTime}
                                                        onChange={(date) => setFieldValue('lunch.endTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                        </CombineInputGroup>

                                        <InputGroup className="md:mt-2">
                                            <Label>Lunch Details</Label>
                                            <FieldWrapper>
                                                <Field
                                                    as="textarea"
                                                    name="lunch.details"
                                                    placeholder="Enter lunch menu details"
                                                    className="details-input"
                                                />
                                            </FieldWrapper>
                                        </InputGroup>
                                    </MealSection>

                                    {/* Snacks Section */}
                                    <MealSection>
                                        <MealTitle>Snacks</MealTitle>
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label>Start Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.snacks.startTime}
                                                        onChange={(date) => setFieldValue('snacks.startTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label>End Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.snacks.endTime}
                                                        onChange={(date) => setFieldValue('snacks.endTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                        </CombineInputGroup>

                                        <InputGroup className="md:mt-2">
                                            <Label>Snacks Details</Label>
                                            <FieldWrapper>
                                                <Field
                                                    as="textarea"
                                                    name="snacks.details"
                                                    placeholder="Enter snacks menu details"
                                                    className="details-input"
                                                />
                                            </FieldWrapper>
                                        </InputGroup>

                                    </MealSection>

                                    {/* Dinner Section */}
                                    <MealSection>
                                        <MealTitle>Dinner</MealTitle>
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label>Start Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.dinner.startTime}
                                                        onChange={(date) => setFieldValue('dinner.startTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                            <InputGroup>
                                                <Label>End Time</Label>
                                                <FieldWrapper>
                                                    <DatePicker
                                                        selected={values.dinner.endTime}
                                                        onChange={(date) => setFieldValue('dinner.endTime', date)}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={15}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        placeholderText="Select time"
                                                    />
                                                </FieldWrapper>
                                            </InputGroup>
                                        </CombineInputGroup>

                                        <InputGroup className="md:mt-2">
                                            <Label>Dinner Details</Label>
                                            <FieldWrapper>
                                                <Field
                                                    as="textarea"
                                                    name="dinner.details"
                                                    placeholder="Enter dinner menu details"
                                                    className="details-input"
                                                />
                                            </FieldWrapper>
                                        </InputGroup>

                                    </MealSection>

                                    <ActionSection>
                                        <SideCancelBtn type="button" onClick={handleClose}>
                                            Cancel
                                        </SideCancelBtn>
                                        <SubmitBtn
                                            type="submit"
                                            disabled={selectedData.id ? editMenuLoading : addMenuLoading}
                                        >
                                            {selectedData.id
                                                ? (editMenuLoading ? "Updating..." : "Update")
                                                : (addMenuLoading ? "Submitting..." : "Submit")
                                            }
                                        </SubmitBtn>
                                    </ActionSection>
                                </Wrapper>
                            </ScrollableContent>
                        </Form>

                    )}
                </Formik>
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-6 sticky top-0 z-10`;
const Title = tw.h1`text-white text-lg font-medium`;
const MealSection = tw.div`p-4 border border-gray-200 rounded-lg`;
const MealTitle = tw.h3`text-lg font-semibold mb-2 text-primary-color`;

export default AddFoodMenu;